import { createTextVNode as _createTextVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-the-page-m02__form c-form-inner" }
const _hoisted_2 = { class: "p-the-page-m02__icon" }
const _hoisted_3 = {
  for: "icon",
  class: "p-the-page-m02__icon__label"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  type: "button",
  for: "icon",
  class: "p-the-page-m02__icon_user_image__button"
}
const _hoisted_6 = { class: "p-the-page-m02__icon_user_image__button__icon" }
const _hoisted_7 = {
  key: 0,
  class: "p-form-group"
}
const _hoisted_8 = { class: "p-form-button-group" }
const _hoisted_9 = { class: "p-form-button-group__vertical" }
const _hoisted_10 = { class: "p-form-button-group__vertical" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconCamera = _resolveComponent("IconCamera")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_IconUserImage = _resolveComponent("IconUserImage")!
  const _component_FormLabel = _resolveComponent("FormLabel")!
  const _component_InputTextarea = _resolveComponent("InputTextarea")!
  const _component_ValidationErrorText = _resolveComponent("ValidationErrorText")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!
  const _component_TheTemplateM = _resolveComponent("TheTemplateM")!

  return (_openBlock(), _createBlock(_component_TheTemplateM, { class: "p-the-page-m02" }, {
    heading: _withCtx(() => _cache[5] || (_cache[5] = [
      _createTextVNode("プロフィール編集", -1)
    ])),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", {
          ref: "form",
          action: "/my-page/profile-update-complete.html",
          method: "put",
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.id) = $event)),
            type: "hidden",
            name: "id"
          }, null, 512), [
            [_vModelText, _ctx.id]
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.icon) = $event)),
            type: "hidden",
            name: "icon"
          }, null, 512), [
            [_vModelText, _ctx.icon]
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", _hoisted_3, [
              _createVNode(_component_IconUserImage, {
                size: 120,
                class: "p-the-page-m02__icon_user_image"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _ctx.iconPreview,
                    alt: '',
                    class: "p-the-page-m02__icon__img"
                  }, null, 8, _hoisted_4),
                  _createElementVNode("button", _hoisted_5, [
                    _createElementVNode("i", _hoisted_6, [
                      _createVNode(_component_IconBase, {
                        width: 15,
                        height: 15,
                        "view-box": "0 0 15 15"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_IconCamera)
                        ]),
                        _: 1
                      })
                    ]),
                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "p-the-page-m02__icon_user_image__button__text" }, "写真を変更", -1))
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("input", {
                id: "icon",
                type: "file",
                name: "icon",
                class: "p-the-page-m02__icon_user_image__input_file",
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectedIconFile && _ctx.selectedIconFile(...args)))
              }, null, 32)
            ])
          ]),
          (_ctx.bioField)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_FormLabel, { for: "bio" }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("自己紹介", -1)
                  ])),
                  _: 1,
                  __: [7]
                }),
                _createVNode(_component_InputTextarea, {
                  id: "bio",
                  modelValue: _ctx.bioField.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bioField.value) = $event)),
                  name: "bio",
                  error: _ctx.bioField.errorMessage
                }, null, 8, ["modelValue", "error"]),
                _withDirectives(_createVNode(_component_ValidationErrorText, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.bioField?.errorMessage), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.bioField.errorMessage]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_ButtonMain, {
                type: "submit",
                disabled: !_ctx.form?.meta?.invalid,
                onClickButton: _ctx.updateProfile
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("保存", -1)
                ])),
                _: 1,
                __: [8]
              }, 8, ["disabled", "onClickButton"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_ButtonMain, {
                tag: 'a',
                href: "/my-page/",
                kind: 'cancel'
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode("キャンセル", -1)
                ])),
                _: 1,
                __: [9]
              })
            ])
          ])
        ], 544)
      ])
    ]),
    _: 1
  }))
}